<app-title-bar [title]='"Exportar Salida Gráfica"' [icon]="'print'"></app-title-bar>
<div id="printContainer"></div>